var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImcNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 169,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 44,
    cy: 165,
    rx: 44,
    ry: 4,
    fill: "#36B37E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 99.76c2.945 0 5.413-2.322 5.586-5.332.281-4.908.412-9.413.414-13.56-.03-21.363-3.402-33.188-8.004-40.297-2.3-3.53-4.987-5.793-7.473-7.047-2.351-1.198-4.42-1.485-5.687-1.508-.105-.007-.209-.016-.314-.016h-27.04c-.106 0-.21.01-.316.016-1.268.024-3.338.309-5.689 1.507-3.764 1.889-7.822 6.018-10.663 13.336C10.939 54.205 9.01 64.827 9 80.867c0 4.146.134 8.654.419 13.564.175 3.007 2.641 5.329 5.582 5.329.112 0 .223-.004.335-.01 3.087-.184 5.442-2.863 5.263-5.985a222.207 222.207 0 0 1-.401-12.898c-.023-17.145 2.448-26.774 4.876-31.798v106.18c0 4.835 3.875 8.751 8.652 8.751 4.78 0 8.654-3.916 8.654-8.751V91.352h3.244v63.897c0 4.835 3.875 8.751 8.652 8.751 4.779 0 8.654-3.916 8.654-8.751V49.104c.415.86.833 1.846 1.245 2.997 1.972 5.531 3.63 14.604 3.626 28.767 0 3.904-.125 8.193-.395 12.9-.18 3.123 2.177 5.802 5.264 5.983.11.007.221.01.33.01zM43 28c7.732 0 14-6.268 14-14S50.732 0 43 0 29 6.268 29 14s6.268 14 14 14z",
    fill: "#36B37E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImcNormal);
export default __webpack_public_path__ + "static/media/IMC_Normal.e8f0494d.svg";
export { ForwardRef as ReactComponent };